import types from './types'
import { Staff } from '@/api'
import { Message } from 'element-ui'
import MessageBox from 'el-message-box-custom-button'
import { generateActionsFor } from '@/store/tools'
import { debounce } from 'lodash'

export default {
  ...generateActionsFor({
    updateFilters: types.UPDATE_FILTERS,
    changePage: types.CHANGE_PAGE,
    changePageSize: types.CHANGE_PAGE_SIZE,
    changeCurrentStaff: types.CHANGE_CURRENT_STAFF,
    openDialogForAdding: types.OPEN_DIALOG_FOR_ADDING,
    openDialogForUpdating: types.OPEN_DIALOG_FOR_UPDATING,
    updateStaffDialogVisible: types.UPDATE_STAFF_DIALOG_VISIBLE,
    changeLoading: types.CHANGE_LOADING,
    resetQueryInfo: types.RESET_QUERY_INFO
  }),

  refresh: debounce(async function({ commit, getters }) {
    commit(types.CHANGE_LOADING, true)
    try {
      let { items: staffs, total } = await Staff.retrieve(getters.queryInfo)

      commit(types.REFRESH, {
        staffs,
        total
      })
    } finally {
      commit(types.CHANGE_LOADING, false)
    }
  }, 200),

  async roleChange({ commit, dispatch }) {
    dispatch('resetQueryInfo')
  },

  async add({ commit }, newItem) {
    let newStaff = await Staff.add(newItem)
    commit(types.ADD, newStaff)
    Message.success('新建成功！')
  },

  async delete({ commit, dispatch }, { row, index }) {
    await MessageBox({
      title: '提示',
      message: '如果仅想禁用该账号登录，您也可以设置员工状态为离职。删除会清除该员工账号全部信息，确认继续吗？',
      showCancelButton: false,
      showConfirmButton: false,
      buttons: [
        {
          text: '取消'
        },
        {
          type: 'primary',
          text: '去设置状态',
          action: button => {
            dispatch('openDialogForUpdating', row)
          }
        },
        {
          type: 'warning',
          text: '确定',
          loading: false,
          action: async button => {
            try {
              button.loading = true
              await Staff.remove(row.id)
              commit(types.DELETE, index)
              Message.success('删除成功！')
            } finally {
              button.loading = false
            }
          }
        }
      ]
    })
  },

  async update({ commit }, data) {
    let updatedStaff = await Staff.edit(data)
    commit(types.UPDATE, updatedStaff)
    Message.success('保存成功！')
  }
}
